'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 12px;\n  right: 26px;\n  cursor: not-allowed;\n'], ['\n  position: absolute;\n  top: 12px;\n  right: 26px;\n  cursor: not-allowed;\n']);

// hixme-ui


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spinner = require('@hixme-ui/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _SelectBase = require('./SelectBase');

var _SelectBase2 = _interopRequireDefault(_SelectBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerContainer = exports.SpinnerContainer = _styledComponents2.default.span(_templateObject);

var Select = function Select(_ref) {
  var list = _ref.list,
      children = _ref.children,
      placeholder = _ref.placeholder,
      loading = _ref.loading,
      props = (0, _objectWithoutProperties3.default)(_ref, ['list', 'children', 'placeholder', 'loading']);

  if (loading) {
    return _react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      _react2.default.createElement(
        _SelectBase2.default,
        (0, _extends3.default)({}, props, { placeholder: placeholder, disabled: true }),
        placeholder && _react2.default.createElement(
          'option',
          { disabled: true, value: '' },
          placeholder
        ),
        list && list.map(function (item) {
          return _react2.default.createElement(
            'option',
            {
              key: 'hui:select-' + item.name + '-' + item.id,
              value: item.id
            },
            item.name
          );
        }),
        !list && children
      ),
      _react2.default.createElement(
        SpinnerContainer,
        null,
        _react2.default.createElement(
          _spinner2.default,
          { animate: true, duration: '2s' },
          _react2.default.createElement(_icon2.default, { cog: true, lighter: true, size: 1.2 })
        )
      )
    );
  }

  return _react2.default.createElement(
    _SelectBase2.default,
    (0, _extends3.default)({}, props, { placeholder: placeholder }),
    placeholder && _react2.default.createElement(
      'option',
      { disabled: true, value: '' },
      placeholder
    ),
    list && list.map(function (item) {
      return _react2.default.createElement(
        'option',
        {
          key: 'hui:select-' + item.name + '-' + item.id,
          value: item.id
        },
        item.name
      );
    }),
    !list && children
  );
};

Select.displayName = 'hui:Select';
Select.huiName = 'Select';

Select.propTypes = {
  children: _propTypes2.default.any,
  loading: _propTypes2.default.bool,
  list: _propTypes2.default.array,
  placeholder: _propTypes2.default.string
};

Select.defaultProps = {
  children: null,
  list: undefined,
  loading: false,
  placeholder: null
};

exports.default = Select;
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// ../select/lib/Select.js
// module id = 708
// module chunks = 0